import { render, staticRenderFns } from "./Customerproducts.vue?vue&type=template&id=c8d28e7e&scoped=true&"
import script from "./Customerproducts.vue?vue&type=script&lang=js&"
export * from "./Customerproducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d28e7e",
  null
  
)

export default component.exports